import * as React from 'react';
import {PowerSettingsNew} from "@mui/icons-material";
import Menu from '@mui/material/Menu';
import {Box, Button, Divider, IconButton} from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import { useGetBasicInformationQuery } from "store/services/authentication/authentication";
import bubo from "assets/images/bubo-empty.svg";

export const AvatarButton = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const { data } = useGetBasicInformationQuery();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        sx={{
          '& .MuiMenu-root': {
            flexGrow: 0
          }
        }}
      >
        <Avatar alt="Sin imagen" src={data?.data?.logoDecoded ? data?.data?.logoDecoded : bubo} />
      </IconButton>
      <Menu
        id="basic-menu"
        elevation={1}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        keepMounted
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        sx={{
          '&	.MuiMenu-paper': {
            border: '1px solid #d3d4d5',
            width: '220px',
            margin: '5px 0 0 0',
            marginTop: '-2px'
          }
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Typography component={'span'} type="title" color="inherit" style={{ flex: 1 }} align={"center"}>
          <Box sx={{display: 'flex', justifyContent: 'center'}}>
            <Avatar
              alt="Sin imagen"
              src={data?.data?.logoDecoded ? data?.data?.logoDecoded : bubo}
              sx={{ width: 65, height: 65 }}
            />
          </Box>
          <Typography variant="subtitle1" component="h6">
            {data?.data?.tenant?.business_name}
          </Typography>
          <Typography variant="subtitle1" component="h6">
            {data?.data?.tenant?.email}
          </Typography>
        </Typography>
        <Divider sx={{marginTop: 1, marginBottom: 1}} />
        <Typography type="title" color="inherit" style={{ flex: 1, marginBottom:'10px' }} align={"center"}>
          <Button
            variant="outlined"
            size={'small'}
            color={'inherit'}
            startIcon={<PowerSettingsNew />}
            sx={{
              color: '#666666',
              border: '1px solid #bfbfbf',
              height: '30px',
              textTransform: 'capitalize',
              fontSize: '13px',
              lineHeight: 'normal',
            }}
            onClick={e => {
              window.location.assign(`${process.env.REACT_APP_LOBBY_URL}/api/logout`)
            }}
          >
            Cerrar sesión
          </Button>
        </Typography>
      </Menu>
    </>
  );
}
